
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import French translations
import frCommon from './locales/fr/common.json';
import frMenu from './locales/fr/menu.json';
import frHero from './locales/fr/hero.json';
import frFeatures from './locales/fr/features.json';
import frVision from './locales/fr/vision.json';
import frResponsibleAI from './locales/fr/responsibleAI.json';
import frMetaRepository from './locales/fr/meta_repository.json';
import frRNCP from './locales/fr/rncp.json';
import frRecruiters from './locales/fr/recruiters.json';
import frHR from './locales/fr/hr.json';
import frTraining from './locales/fr/training.json';
import frIndividuals from './locales/fr/individuals.json';
import frInterim from './locales/fr/interim.json';
import frContact from './locales/fr/contact.json';
import frFooter from './locales/fr/footer.json';
import frSearchEngine from './locales/fr/search_engine.json';
import frTargetAudience from './locales/fr/targetAudience.json';

// Import English translations
import enCommon from './locales/en/common.json';
import enMenu from './locales/en/menu.json';
import enHero from './locales/en/hero.json';
import enFeatures from './locales/en/features.json';
import enVision from './locales/en/vision.json';
import enResponsibleAI from './locales/en/responsibleAI.json';
import enMetaRepository from './locales/en/meta_repository.json';
import enRNCP from './locales/en/rncp.json';
import enRecruiters from './locales/en/recruiters.json';
import enHR from './locales/en/hr.json';
import enTraining from './locales/en/training.json';
import enIndividuals from './locales/en/individuals.json';
import enInterim from './locales/en/interim.json';
import enContact from './locales/en/contact.json';
import enFooter from './locales/en/footer.json';
import enSearchEngine from './locales/en/search_engine.json';
import enTargetAudience from './locales/en/targetAudience.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        common: frCommon,
        menu: frMenu,
        hero: frHero,
        features: frFeatures,
        vision: frVision,
        responsibleAI: frResponsibleAI,
        meta_repository: frMetaRepository,
        rncp: frRNCP,
        recruiters: frRecruiters,
        hr: frHR,
        training: frTraining,
        individuals: frIndividuals,
        interim: frInterim,
        contact: frContact,
        footer: frFooter,
        search_engine: frSearchEngine,
        targetAudience: frTargetAudience
      },
      en: {
        common: enCommon,
        menu: enMenu,
        hero: enHero,
        features: enFeatures,
        vision: enVision,
        responsibleAI: enResponsibleAI,
        meta_repository: enMetaRepository,
        rncp: enRNCP,
        recruiters: enRecruiters,
        hr: enHR,
        training: enTraining,
        individuals: enIndividuals,
        interim: enInterim,
        contact: enContact,
        footer: enFooter,
        search_engine: enSearchEngine,
        targetAudience: enTargetAudience
      }
    },
    lng: localStorage.getItem('i18nextLng') || 'fr',
    fallbackLng: 'fr',
    ns: ['common', 'menu', 'hero', 'features', 'vision', 'responsibleAI', 'meta_repository', 'rncp', 'recruiters', 'hr', 'training', 'individuals', 'interim', 'contact', 'footer', 'search_engine', 'targetAudience'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false
    },
    debug: true
  });

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;
